import { CtaStrip, MarketingPage } from '../../components/MarketingPage';

export function Contact() {
  return (
    <MarketingPage
      seoTitle="Contact — AuctiSync"
      seoDescription="Get in touch with AuctiSync. Book a demo, talk to sales, or drop a note about migrating from legacy auction software."
      canonicalPath="/contact"
      eyebrow="Contact"
      headline="Let's talk about your auction operation."
      subhead="We're still in founder-led sales through Month 12. That means every demo is with someone who can actually change the product. Drop a note or book a call."
    >
      <section className="mx-auto max-w-4xl px-6 py-16">
        <div
          className="rounded-lg border p-8 md:p-12"
          style={{ borderColor: 'var(--border)', background: 'var(--surface-elev)' }}
        >
          <h2 className="text-2xl font-bold tracking-tight" style={{ color: 'var(--text)' }}>
            Fastest paths to reach us
          </h2>
          <ul className="mt-6 space-y-4" style={{ color: 'var(--text)' }}>
            <li>
              <span className="font-semibold">Email:</span>{' '}
              <a
                href="mailto:support@auctisync.com"
                className="underline-offset-4 hover:underline"
                style={{ color: 'var(--brand-accent)' }}
              >
                support@auctisync.com
              </a>
            </li>
            <li>
              <span className="font-semibold">Platform login (existing tenants):</span>{' '}
              <a
                href="https://app.auctisync.com/admin"
                className="underline-offset-4 hover:underline"
                style={{ color: 'var(--brand-accent)' }}
              >
                app.auctisync.com/admin
              </a>
            </li>
            <li>
              <span className="font-semibold">Docs:</span>{' '}
              <a
                href="https://help.auctisync.com"
                className="underline-offset-4 hover:underline"
                style={{ color: 'var(--brand-accent)' }}
              >
                help.auctisync.com
              </a>
            </li>
          </ul>
          <p className="mt-6 text-sm" style={{ color: 'var(--text-muted)' }}>
            A self-serve demo signup is on the roadmap. For now, email is the fastest way to get on
            our calendar.
          </p>
        </div>
      </section>

      <CtaStrip
        headline="Prefer to see the pricing first?"
        primaryLabel="See pricing"
        primaryHref="/pricing"
        secondaryLabel="Read the DTA case study"
        secondaryHref="/case-studies/dta"
      />
    </MarketingPage>
  );
}
